// ---------------------------------------------------------------------------
// Tab 1 — Transaction Details (read-only field grid)
// ---------------------------------------------------------------------------

import { formatAmount } from '@/utils/formatters';
import type { PaymentDetail } from './types';
import { parseCalendarDate } from '@/lib/calendar-date';

interface Props {
  payment: PaymentDetail;
}

/** La date de valeur, ou « Pending » tant qu'il n'y a pas eu de reglement (#169). */
function formatDate(iso: string): string {
  const date = parseCalendarDate(iso);
  if (!date) return 'Pending';
  return date.toLocaleDateString('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('en-GB', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZoneName: 'short',
  });
}

function Field({ label, value }: { label: string; value: string }) {
  return (
    <div className="flex items-start justify-between border-b border-[#f0f0f0] py-2.5 last:border-b-0">
      <span className="text-[13px] font-medium text-[#888]">{label}</span>
      <span className="text-right text-[13px] font-semibold text-[#333]">{value}</span>
    </div>
  );
}

export function TransactionDetailsTab({ payment }: Props) {
  return (
    <div className="space-y-1">
      <Field label="Client" value={payment.client_name} />
      <Field label="Beneficiary" value={payment.beneficiary_label} />
      <Field label="IBAN" value={payment.beneficiary_iban} />
      <Field label="BIC" value={payment.beneficiary_bic} />
      <Field label="Amount" value={formatAmount(payment.amount, payment.currency)} />
      <Field label="Reference" value={payment.reference} />
      <Field label="Value Date" value={formatDate(payment.value_date)} />
      <Field label="Created" value={formatDateTime(payment.created_at)} />
    </div>
  );
}
